import { Strategy } from './types';

export const getAvailableStrategies = (roundNumber: number) => {
  if (roundNumber < 7) {
    return [Strategy.green, Strategy.red, Strategy.none];
  } else {
    return [Strategy.green, Strategy.red, Strategy.orange, Strategy.blue, Strategy.yellow, Strategy.none];
  }
};
